export const TEXT_INPUT_MAX_LENGTH = 30;
export const PHONE_INPUT_MAX_LENGTH = 16;
